import React from 'react';

import {
  ActiveAlertBox,
  ActiveAlertTitle,
  ActiveDebitSwitch,
  ArrowIcon,
  Container,
  PlacaColumn,
  PlacaContainer,
  PlacaHeader,
  PlacaInfo,
  PlacaInfoContainer,
  PlacaInfoText,
  PlacaSubtitle,
  PlacaTitle,
} from './styles';
import {Icon} from '../../Interface/Typographies/Icon';
import {useTheme} from 'styled-components/native';

interface Props {
  action: () => void;
  title: string;
  subtitle: string;
  isEnabled: boolean;
  onValueChange: () => void;
}

export function Placa({
  action,
  title,
  subtitle,
  isEnabled,
  onValueChange,
}: Props) {
  const theme = useTheme();

  return (
    <Container>
      <PlacaContainer activeOpacity={0.7} onPress={action}>
        <PlacaHeader>
          <PlacaColumn>
            <Icon name="car" />
            <PlacaInfo>
              <PlacaTitle>{title}</PlacaTitle>
              <PlacaSubtitle>{subtitle}</PlacaSubtitle>
            </PlacaInfo>
          </PlacaColumn>
          <ArrowIcon name="chevron-right" />
        </PlacaHeader>
        <PlacaInfoContainer>
          <PlacaInfoText>
            Clique para ver detalhes do veículo e consultar os débitos.
          </PlacaInfoText>
        </PlacaInfoContainer>
      </PlacaContainer>

      <ActiveAlertBox>
        <ActiveAlertTitle>Ativar alerta de multas</ActiveAlertTitle>
        <ActiveDebitSwitch
          trackColor={{
            false: theme.colors.border,
            true: theme.colors.primary,
          }}
          ios_backgroundColor={theme.colors.border}
          onValueChange={onValueChange}
          value={isEnabled}
        />
      </ActiveAlertBox>
    </Container>
  );
}
